<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <ListPanel v-else :portal="portal" :file-categories="fileCategories"/>
  </div>
</template>

<script>
import http from '@/http'
import ListPanel from '../../../../../../../components/Administration/ContentFiles/Panels/List'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {ListPanel, LoadingContainer},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      fileCategories: null,

      loading: true,
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-file-categories', {'filter[portal_id]': this.portal.id}).then(response => {
        this.fileCategories = response.data.data

        this.loading = false
      })
    },
  }

}
</script>
